var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"outlined":"","shaped":""},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }